import { render } from "./health-records.vue?vue&type=template&id=ce194ba4"
import script from "./health-records.vue?vue&type=script&lang=js"
export * from "./health-records.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__